﻿/**
 * @deprecated use the TAB_NAMES constant instead. This class will be removed in a future release.
 */
export default class TabNames {
	product: {
		overview: string;
		technicalSpecifications: string;
		curves: string;
		technicalsoftware: string;
		drawings: string;
		components: string;
		accessories: string;
		applications: string;
		documentation: string;
		technology: string;
		submittals: string;
		faq: string;
	};
	freeText: { products: string; pages: string; documentsandvideos: string; all: string };
	applicationDetailTabs: string[];
	productTabs: string[];
	freeTextSearchTabs: string[];
	constructor() {
		this.product = {
			overview: "overview",
			technicalSpecifications: "specifications",
			curves: "curves",
			technicalsoftware: "technicalsoftware",
			drawings: "drawings",
			components: "components",
			accessories: "accessories",
			applications: "applications",
			documentation: "documentation",
			technology: "technology",
			submittals: "submittals",
			faq: "faq",
		};

		this.freeText = {
			products: "products",
			pages: "pages",
			documentsandvideos: "documentsandvideos",
			all: "all",
		};

		this.applicationDetailTabs = ["products", "services", "brands", "casestudies", "resources"];

		this.productTabs = [
			"overview",
			"specifications",
			"curves",
			"technicalsoftware",
			"drawings",
			"components",
			"accessories",
			"applications",
			"documentation",
			"technology",
			"submittals",
			"faq",
		];

		this.freeTextSearchTabs = ["products", "pages", "documentsandvideos", "all"];
	}
}

/**
 * @warn For events use events.TAB_LOAD_EVENTS instead.
 */
export const TAB_NAMES = {
	product: {
		overview: "overview",
		technicalSpecifications: "specifications",
		curves: "curves",
		technicalsoftware: "technicalsoftware",
		drawings: "drawings",
		components: "components",
		accessories: "accessories",
		applications: "applications",
		documentation: "documentation",
		technology: "technology",
		submittals: "submittals",
		faq: "faq",
	},
	freeText: {
		products: "products",
		pages: "pages",
		documentsandvideos: "documentsandvideos",
		all: "all",
	},
	applicationDetailTabs: ["products", "services", "brands", "casestudies", "resources"],
	productTabs: [
		"overview",
		"specifications",
		"curves",
		"technicalsoftware",
		"drawings",
		"components",
		"accessories",
		"applications",
		"documentation",
		"technology",
		"submittals",
		"faq",
	],
	freeTextSearchTabs: ["products", "pages", "documentsandvideos", "all"],
} as const;
